import React from 'react';
import { Alpha } from '../../..';
import Hue from '../../../color-hue';
import EyeDropper from '../../../color-sketch-picker/eye-dropper';
import { Bar, SelectPreview } from '../../../color-sketch-picker/tool-group';
import { HsvaColor } from '../../../utils/color-convert';

// 颜色滑块组
const ColorSliderGroup = ({ hsva, handleChange }: { hsva: HsvaColor; handleChange: (hsva: HsvaColor) => void }) => {
    return (
        <div className="c-color-sketch-picker__tool--setting">
            <Hue
                width="auto"
                height={12}
                hsva={hsva}
                pointer={Bar}
                innerProps={{
                    style: { marginLeft: 0, marginRight: 10 },
                }}
                radius={8}
                onChange={(newHue) => handleChange({ ...hsva, ...newHue })}
            />
            <Alpha
                width="auto"
                height={12}
                hsva={hsva}
                pointer={Bar}
                style={{ marginTop: 8 }}
                innerProps={{
                    style: { marginLeft: 0, marginRight: 10 },
                }}
                radius={8}
                onChange={(newAlpha) => {
                    handleChange({ ...hsva, ...{ a: newAlpha.a } });
                }}
            />
        </div>
    );
};

type Props = {
    useRGBAInput?: boolean;
    hsva: HsvaColor;
    handleChange: (hsva: HsvaColor) => void;

    setHex: (hex: string) => void;
    setHsva: (hsva: HsvaColor) => void;
};

const ToolGroup = ({ useRGBAInput, hsva, handleChange, setHex, setHsva }: Props) => {
    if (useRGBAInput) {
        return (
            <div className="c-color-sketch-picker__tool input_RGBA">
                <EyeDropper setHex={setHex} setHsva={setHsva} handleChange={handleChange} />
                <ColorSliderGroup hsva={hsva} handleChange={handleChange} />
                <SelectPreview hsva={hsva} />
            </div>
        );
    }

    return (
        <div className="c-color-sketch-picker__tool">
            <SelectPreview hsva={hsva} />
            <ColorSliderGroup hsva={hsva} handleChange={handleChange} />
        </div>
    );
};

export default ToolGroup;
